export const STATE_COL_SUFFIX = "__state";
export const CODE_SEPARATOR = "_";
export const isCodeError = (codes) => {
    return codes.filter((code) => parseInt(code) > 199).length > 0;
};
export const isCodeInfo = (codes) => {
    return codes.filter((code) => parseInt(code) < 100).length > 0;
};
export const isCodeWarning = (codes) => {
    return codes.filter((code) => parseInt(code) > 99 && parseInt(code) < 200).length > 0;
};
export const DELETABLE_TYPES = ["ACTUAL_PROCESS_DATA"];
export var FileState;
(function (FileState) {
    FileState["MISSING"] = "missing";
    FileState["SUCCESS"] = "success";
    FileState["ERRROR"] = "error";
    FileState["WARNING"] = "warning";
})(FileState || (FileState = {}));
export var ColDataType;
(function (ColDataType) {
    ColDataType["boolean"] = "boolean";
    ColDataType["integer"] = "integer";
    ColDataType["float"] = "float";
    ColDataType["string"] = "string";
    ColDataType["decimal"] = "decimal";
    ColDataType["date"] = "date";
})(ColDataType || (ColDataType = {}));
